import { createHttpEndpoint } from '../../utils'

import type { GetSellerOrderFinancialDetails } from './seller.types'

export const getSellerOrderFinancialDetails =
  createHttpEndpoint<GetSellerOrderFinancialDetails>({
    method: 'GET',
    operationId: 'getSellerOrderFinancialDetails',
    path: '/finance/seller-ledger/live-balances/orders/:orderId',
  })
